import AnalyticsWebClient, {
  envType,
  originType,
  platformType,
} from '@atlassiansox/analytics-web-client';

import ClientConfig from 'debug/client-config';

let origin = originType.WEB;
let platform = null;

if (ClientConfig.get('appId') === 'desktop') {
  origin = originType.DESKTOP;

  const analyticsContext = ClientConfig.get('analyticsContext');

  if (analyticsContext) {
    switch (analyticsContext.platform) {
      case 'darwin':
        platform = platformType.MAC;
        break;
      case 'win32':
        platform = platformType.WINDOWS;
        break;
      case 'linux':
        platform = platformType.LINUX;
        break;
    }
  }
}

export default new AnalyticsWebClient({
  env: envType[window.analyticsWebClientEnv],
  product: 'trello',
  version: window.clientVersion,
  origin,
  platform,
});



// WEBPACK FOOTER //
// ./app/scripts/lib/analytics.js